import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { IGrado } from "../entidad/Grado";
import { MEscuela } from "../model/MEscuela";
import { MGrado } from "../model/MGrado";
import { MGrupo } from "../model/MGrupo";
import { DataModuloMain } from "../ModuloMain";
import { DataUtil } from "../util/Util";

export const _DICC_GRADO: Map<number, MGrado> = new Map();
/** Map<idGrado, Map<idGrupo, Grupo>> */
export var _DICC_ASIGNACION_GRADO_GRUPOS: Map<number, Map<number, MGrupo>> = new Map();

const RequestID = Entidad.CTipoRequest.Grado;

export async function _SvGradoObtenerLista(escuelas: Array<MEscuela>): Promise<DataDRequest.IRequestResponseListA<IGrado>[]> {
    const url = _APP_CONFIG.URL_RSTV2 + "grado/ObtenerLista";
    const results = new Array<DataDRequest.IRequestResponseListA<IGrado>>();

    for (let escuela of escuelas) {
        const currentDateStr = await DataUtil._GetMaxDate(RequestID, escuela.IdKinder);
        const params = {
            "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
            "IdEscuela": escuela.IdKinder,
            "Modificacion": currentDateStr
        }

        let result = await DataDRequest._Request4List(url, "GET", params, RequestID, escuela.IdKinder);
        results.push(result);
    }
    return results;
}

export function _SvGradoNuevo(datoN: MGrado): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = _APP_CONFIG.URL_RSTV2 + "grado/NuevoGrado";
    const params = {
        "Nombre": datoN.Nombre,
        "IdEscuela": datoN.IdKinder,
        "IdEscolaridad": datoN.IdEscolaridad,
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }

    return new Promise(function (resolve, reject) {
        DataDRequest._Request(url, "POST", params, (result: DataDRequest.IRequestResponseBase) => {
            resolve({
                Resultado: (result?.Resultado || -100),
                TipoRequest: Entidad.CTipoRequest.Grado
            });
        });
    });
}

// *************************************************************
// LOCAL DATA
// *************************************************************

/**
 * @param idGrado > IdNivel
 * @returns
 */
export function _LOCALDATA_GetGruposEnGrado(idGrado: number): Map<number, MGrupo> {
    return (_DICC_ASIGNACION_GRADO_GRUPOS.get(idGrado) || new Map());
}

export function _LOCALDATA_GetAlumnosEnGrado(idGrado: number): Array<Entidad.IAlumno> {

    return DataModuloMain._GetReqDataArrayByName("Alumno")
        .filter(d => (d.IdGrado == idGrado));
}
